import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  FormControl,
  Alert,
  Button as MuiButton
} from '@mui/material';
import { Power, PowerOff } from 'lucide-react';

const ActivateDeactivatePlanDialog = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
  plan,
  action, // 'activate' or 'deactivate'
  reason,
  onReasonChange
}) => {
  const isActivate = action === 'activate';
  
  const handleConfirm = () => {
    onConfirm(action, reason);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="flex items-center space-x-2">
        {isActivate ? (
          <Power className="w-5 h-5 text-green-500" />
        ) : (
          <PowerOff className="w-5 h-5 text-orange-500" />
        )}
        <span>
          {isActivate ? 'Activate' : 'Deactivate'} Subscription Plan
        </span>
      </DialogTitle>
      
      <DialogContent>
        <Typography className="mb-4">
          Are you sure you want to {action} the plan{' '}
          <strong>"{plan?.name}"</strong>?
        </Typography>
        
        <FormControl fullWidth className="mb-3">
          <Typography variant="subtitle2" className="mb-2 text-secondary-700">
            Reason for {isActivate ? 'activation' : 'deactivation'} (optional):
          </Typography>
          <textarea
            minRows={3}
            placeholder={`Enter reason for ${isActivate ? 'activating' : 'deactivating'} this plan...`}
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            style={{ minHeight: '80px' }}
          />
        </FormControl>

        {!isActivate && (
          <Alert severity="warning" className="mt-2">
            Deactivating this plan will make it unavailable for new subscriptions.
            Existing subscribers will not be affected.
          </Alert>
        )}

        {isActivate && (
          <Alert severity="info" className="mt-2">
            Activating this plan will make it available for new subscriptions.
          </Alert>
        )}
      </DialogContent>
      
      <DialogActions>
        <MuiButton 
          onClick={onClose}
          disabled={isLoading}
        >
          Cancel
        </MuiButton>
        <MuiButton 
          onClick={handleConfirm}
          variant="contained"
          color={isActivate ? 'success' : 'warning'}
          disabled={isLoading}
          startIcon={
            isLoading ? null : 
            isActivate ? <Power className="w-4 h-4" /> : <PowerOff className="w-4 h-4" />
          }
        >
          {isLoading 
            ? `${isActivate ? 'Activating' : 'Deactivating'}...` 
            : `${isActivate ? 'Activate' : 'Deactivate'} Plan`
          }
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default ActivateDeactivatePlanDialog;